import { Tooltip } from 'antd';
import classNames from 'classnames';
import { IconBed, IconInfo } from 'components';
import { IconPatient } from 'components/icons/Patient';
import { memo as Memo } from 'react';
import DefaultAvatar from 'assets/images/default-avatar.png';
import { COLORS } from 'utils/colors';
import { CLIENT_STATUS } from 'api/constants';
import { Link } from 'react-router-dom';

export const SingleBed = ({ isBedOccupied, toggleBed, inEdit, isPWClient, client }) => {
  const tooltipBody = () => {
    if (isPWClient) {
      const statusAbbr = client.status?.slice(0, 1).toUpperCase();
      return (
        <div className="flex flex-col p-4 bg-white rounded-xl shadow-block-shadow">
          <div className="flex items-center gap-x-1">
            <img
              className="w-[30px] h-[30px] rounded-full"
              src={client.avatar ? client.avatar : DefaultAvatar}
              alt="Resident"
            />
            {inEdit ? (
              <p className="text-14 text-black font-medium ml-1">
                {client?.firstname} {client?.lastname}
              </p>
            ) : (
              <Link
                to={`/client/${client.user_id}`}
                className="text-14 text-black font-medium ml-1"
              >
                {client?.firstname} {client?.lastname}
              </Link>
            )}
            <p className="w-6 h-6 rounded-full bg-white shadow-block-shadow flex justify-center items-center">
              <span
                className={classNames(
                  'uppercase text-xl leading-5 font-medium',
                  { 'text-blue': statusAbbr === 'N' },
                  { 'text-orange': statusAbbr === 'I' },
                  { 'text-green': statusAbbr === 'C' },
                  { 'text-red': statusAbbr === 'R' },
                )}
              >
                {statusAbbr === 'R' ? 'E' : statusAbbr}
              </span>
            </p>
          </div>
          <span className="flex-1 border-b border-color-divider min-w-3 my-2" />
          {inEdit ? (
            <div className="flex gap-x-1 px-2 py-1 border border-divider rounded-md">
              <IconBed
                color={
                  isBedOccupied
                    ? client?.status === CLIENT_STATUS.failed ||
                      client?.status === CLIENT_STATUS.completed
                      ? COLORS.green
                      : COLORS.grey
                    : COLORS.red
                }
              />
              <p
                className={`text-14 ${
                  isBedOccupied
                    ? client?.status === CLIENT_STATUS.failed ||
                      client?.status === CLIENT_STATUS.completed
                      ? 'text-black'
                      : 'text-grey'
                    : 'text-black'
                }`}
              >
                Mark as {isBedOccupied ? 'Available' : 'Occupied'}
              </p>
            </div>
          ) : (
            <div className="flex items-center justify-center">
              <IconInfo color={COLORS.blue} className="w-4 h-4" />
              <p className="text-12 text-lightBlue ml-2 font-normal">Occupied by PF25 Resident</p>
            </div>
          )}
        </div>
      );
    }

    return inEdit ? (
      <div className="p-4 bg-white rounded-xl shadow-block-shadow">
        <div className="flex gap-x-1 px-2 py-1 border border-divider rounded-md">
          <IconBed color={isBedOccupied ? COLORS.green : COLORS.red} />
          <p className="text-14 text-black">Mark as {isBedOccupied ? 'Available' : 'Occupied'}</p>
        </div>
      </div>
    ) : (
      isBedOccupied && (
        <div className="flex flex-col p-4 bg-white rounded-xl shadow-block-shadow">
          <span className="flex-1 border-b border-color-divider min-w-3 mb-2" />
          <div className="flex items-center justify-center">
            <IconInfo color={COLORS.blue} className="w-4 h-4" />
            <p className="text-12 text-lightBlue ml-2 font-normal">Occupied manually</p>
          </div>
        </div>
      )
    );
  };

  const handleClick = () => {
    if (!inEdit) return;

    if (isPWClient) {
      if (!isBedOccupied) return;

      if (client.changes_allowed) {
        toggleBed(client);
      }

      return;
    }

    toggleBed();
  };

  return (
    <Tooltip
      destroyTooltipOnHide
      title={tooltipBody()}
      color="transparent"
      overlayInnerStyle={{
        padding: '0',
        borderRadius: isPWClient ? '8px' : '0',
        boxShadow: 'none',
      }}
    >
      <div
        onClick={handleClick}
        className={`relative ${isBedOccupied ? (isPWClient && !client.changes_allowed ? 'bg-lightGrey' : 'bg-pink') : 'bg-lightGreen'} 
        ${inEdit && (client?.changes_allowed || client === null) ? 'hover:border-2 hover:border-blue cursor-pointer' : ''} rounded-full w-10 h-10 flex items-center  justify-center`}
      >
        {isPWClient && (
          <IconPatient
            color={COLORS.orange}
            className="absolute top-0 right-0 translate-x-1/3 -translate-y-1/4 p-1 w-5 h-5 rounded-full bg-white"
          />
        )}
        <IconBed
          color={
            isBedOccupied
              ? isPWClient && !client.changes_allowed
                ? COLORS.darkGrey
                : COLORS.red
              : COLORS.green
          }
          className="pointer-events-none"
        />
      </div>
    </Tooltip>
  );
};

export default Memo(SingleBed);
